import { inject, Injectable } from '@angular/core';
import { SettingDbService } from '@shared/database/setting-db.service';
import { conditionIndexesModel, ConditionIndexModel } from '@shared/models/setting.model';
import { map, Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  private settingDbService =  inject(SettingDbService);

  constructor(
    
  ) {
  }


  discountRates$ = this.settingDbService.get$('discountRates').pipe(shareReplay(1));
  conditionIndexes$ = this.settingDbService.get$('conditionIndexes').pipe(
    map(conditionIndexes=>{
      const {id, _version, updatedAt, ...data} = conditionIndexes;
      return {...data}
    }),
    shareReplay(1)
  ) as Observable<conditionIndexesModel>;

  public setDiscountRate(discountRate): Promise<any> {
      let data ={
        id: 'discountRates',
        ...discountRate
      }
      return this.settingDbService.upsert(data);
  }

  
  public setConditionIndex(contitionIndex): Promise<ConditionIndexModel>{
    let data ={
      id: 'conditionIndexes',
      [contitionIndex.key]:contitionIndex
    }
    return this.settingDbService.upsert(data);
  }
}
